import { request } from "../utils/request";
import { getCookie } from "../utils/utils";
export default{
    login:async(payload)=>{
        const response = await request.post("/auth/login",payload);
        console.log(response,"response from auth services");
        return response;
      },
      loginWithGoogle:async(payload)=>{
        return request.post("/auth/loginWithGoogle",payload)
      },
      // Redirect-flow Google sign-in: redeem the #gauth handoff for a token.
      exchangeGoogleHandoff:async(payload)=>{
        return request.post("/auth/oauth-exchange",payload)
      },
      loginWithFacebook:async(payload)=>{
        return request.post("/auth/loginWithFacebook",payload)
      },
      registration:async(payload)=>{
        return request.post("/auth/register",payload);
      },
      forgotPassword:async(payload)=>{
        return request.post("/auth/forgot-password",payload);
      },
      resetPassword:async(payload)=>{
        return request.post("/auth/reset-password",payload);
      },
      logout:async()=>{
        return request.post("/auth/logout","",{
            headers:{
                'Authorization':'Bearer '+getCookie("_aps_t"),
            }
        })
      }
}
